import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {reactive, ref, UnwrapRef, watch, nextTick} from "vue";
import {Rule} from "ant-design-vue/lib/form";
import {message} from "ant-design-vue";
import {designerTeam, getById} from "@/api/designer";

interface Data {
    name: string,
    loading: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'designerTeamForm',
  props: {
    id: {
        type: String,
        default: ''
    },
},
  emits: ["cancel"],
  setup(__props, { expose, emit }) {

const prop = __props;



watch(
    () => prop.id, async () => {
        await nextTick(()=>{
            if(prop.id){
                data.loading = true;
                getById(prop.id).then((res: any)=>{
                    data.name = res.name;
                    data.loading = false;
                })
            }
        })
    },
    {
        immediate: true,
        deep: true,
    }
);

const data: UnwrapRef<Data> = reactive({
    name: "",
    loading: false
})
const formRef = ref();
const rules: Record<string, Rule[]> = {
    name: [
        {
            required: true,
            trigger: "change",
            validator: (rule, value) => {
                if (value == '') {
                    return Promise.reject("请输入设计师团队名称!");
                }else{
                    return Promise.resolve();
                }
            },
        },
    ],
}
const save = ()=>{
    data.loading = true;
    formRef.value
        .validate()
        .then(() => {
            designerTeam({
                id: prop.id,
                name: data.name
            }).then(()=>{
                formRef.value.resetFields()
                message.success("操作成功");
                data.loading = false;
                emit("cancel")
            })
        })
        .catch(() => {
            message.warning("请填写完整表单");
            data.loading = false;
        });
}
expose({save})


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      loading: data.loading,
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      class: "ant-advanced-search-form",
      rules: rules,
      model: data
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "name",
                  label: "名称"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: data.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.name) = $event)),
                      placeholder: "请输入设计师团队名称",
                      "allow-clear": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "model"])
  ]))
}
}

})